import React from 'react'
import SearchPicker from '../common/SearchPicker'

const PatternPicker = (props) => {

    const { state } = props

    const option = (pattern) => <span>{`${pattern.code}, ${pattern.name}`}</span>

    return (
        <SearchPicker
            {...props}
            value={state ? `${state?.code}, ${state?.name}` : ""}
            option={(pattern) => option(pattern)}
        />
    )
}

export default PatternPicker